import React from 'react'
import { pick } from 'lodash-es'
import { useTbViewStore } from '@vt/hooks'
import { Button, Modal } from '@ow/comps'

const Delete = function ({ children }) {
  const { selectedIds, destroyTbData } = useTbViewStore((state) =>
    pick(state, ['selectedIds', 'destroyTbData'])
  )

  return (
    <Modal
      // 新加
      title="提示"
      nested
      size="sm"
      trigger={selectedIds.length && children}
      // eslint-disable-next-line react/no-unstable-nested-components
      footer={({ close }) => (
        <>
          <Button
            type="secondary"
            opacityType="sm"
            style={{ marginRight: '10px' }}
            onClick={() => {
              close()
            }}
          >
            取消
          </Button>
          <Button
            type="primary"
            onClick={() => {
              destroyTbData(selectedIds)
              close()
            }}
          >
            确定
          </Button>
        </>
      )}
    >
      <div className="text-white-400" style={{ fontSize: '14px' }}>
        <div>删除后记录将被移至回收站，您可以在回收站中恢复记录。</div>
      </div>
    </Modal>
  )
}

export default Delete
